module.exports = __webpack_public_path__ + "e5e20b7b15563642be27b5d5ca71f626.png";